// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sqne","controls":"styles_controls__33zt4","charLimit":"styles_charLimit__2lBp0","input":"styles_input__1NWu5","send":"styles_send__2_L_z"};